const initTakeScreenshot = () => {
    //if (window.innerWidth <= 1024) {
    //    return;
    //}
    if (!document.body.classList.contains("transparent-header")) {
        return;
    }
    // Capture screenshot of the page
    //@ts-ignore
    html2canvas(document.body).then(function (canvas) {
        // Create an image element
        const screenshotImage = new Image();
        // Set the source of the image as the canvas data
        screenshotImage.src = canvas.toDataURL();
        // Now you can manipulate the image, retrieve pixels, etc.
        // For example, to retrieve a pixel color at a specific position (x, y):
        const context = canvas.getContext('2d');
        const pixelData = context.getImageData(15, 15, 1, 1).data;
        const red = pixelData[0];
        const green = pixelData[1];
        const blue = pixelData[2];
        // Check if it's a light or dark color
        const brightness = (red + green + blue) / 3;
        if (brightness < 128) {
            document.body.classList.remove("light");
            document.body.classList.add("dark");
        }
        else {
            document.body.classList.remove("dark");
            document.body.classList.add("light");
        }
        //document.body.classList.remove("dark");
        //document.body.classList.add("light");
    });
};
